import React from 'react';
import { Badge } from 'react-bootstrap';

const badgeColors = ["#F9F5FF", "#EFF8FF", "#EEF4FF"];
const badgeClasses = ["label1", "label2", "label3"];

export const BadgesComponent = ({ badges, removeTag }) => {
    return (
        <div className="p-0">
            {badges.map((badge, index) => {
                const randomColor = badgeColors[index % badgeColors.length];
                const randomClass = badgeClasses[index % badgeClasses.length];

                return (
                    <Badge key={index} bg={randomColor} className={randomClass}>
                        {badge}
                        <span
                            style={{ cursor: "pointer", marginLeft: "5px" }}
                            onClick={() => removeTag(badge)}
                        >
                            &times;
                        </span>
                    </Badge>
                );
            })}
        </div>
    );
};
